module.exports = __webpack_public_path__ + "img/alarm.82a7ec06.webp";